var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-floater"},[_c('div',{staticClass:"header"},[_vm._v("Competition ends in:")]),_c('Timers',{attrs:{"expiresOn":_vm.expiresOn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }